export const DEFAULT_PAGINATION = { page: 0, size: 10 } as const;

export const MAX_DATA_MSG =
  'Sorry, we do not serve more than 10000 results for any findings query.';
export const MAX_DATA_ERROR_MSG = 'Maximum 10000 records can be fetched';

export const pageSizeOptions = [10, 20, 50, 100] as const;
